<template>
  <div class="mobile" :class="[
    getPageLayout =='centre'? 'justify-center': '',
    getPageLayout =='left'? 'layout1' : '',
    getPageLayout =='right'? 'layout1 layout1-right' : ''
  ]">
    <div :class="[
      getPageLayout =='centre'? 'layout1 layout1-center mb-4' : '',
    ]">
        <div class="main_conainer">
          <div class="main-header">
            <img class="main-logo" :src="navLogo" />
            <h4 class="mt15 col_secondary fw400 fs24" v-html="setTitle"></h4>
          </div>
          <div class="main-body mt30">
            <slot name="form"></slot>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

export default {
  props: ['title'],
  name: 'Layout1',
  data () {
    return {
      navLogo: '',
      favicon: '',
      cloudName: '',
      bgImage: '',

    }
  },
  computed: {
    ...mapGetters({
      getPageLayout: 'getPageLayout',
      listAllAssets: 'getAllAssets'
    }),
    setTitle () {
      const title = this.title.replace('<cloudName>', `<span class="fwbolder text-transform-none">${this.cloudName}</span>`)
      return `<span class="col_grey95">${title}</span>`
    },
    fullScreen () {
      if (this.listAllAssets && this.listAllAssets.length > 0) {
        return this.listAllAssets[0].metadata.show_fullscreen
      }
      return false
    },
    partnerID () {
      return this.$route.params && this.$route.params.partnerID ? this.$route.params.partnerID : ''
    }
  },
  methods: {
    getImage (name, varName) {
      this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: name }).then(res => {
        if (res && typeof res === 'string') {
          return this[varName] = 'data:image/png;base64,' + res
        }
        if (this.partnerID) {
            this.$router.push({name:'login'})
        }
      })
    },
    getProfileDetails () {
      this.$store.dispatch('ACTION_GET_PROFILE_DETAILS').then(res => {
        if (res) {
          let titleElement = document.getElementById('cloudTitle')
          titleElement.innerHTML = res.name
          this.cloudName = res.name
        }
      })
    },
  },
  watch: {
    favicon () {
      if (this.favicon) {
        let faviconElement = document.getElementById('favicon')
        faviconElement.href = this.favicon
      }
    },
    bgImage () {
      if (this.bgImage) {
        let appElement = document.getElementsByClassName('application--wrap')
        appElement[0].style.background =  'url(' + this.bgImage + ') no-repeat center center fixed'
      }
    }
  },
  created () {
    let navLogo = "logo-main.png"
    let banner = "banner.png"
    if (this.partnerID) {
      navLogo = `${this.partnerID}-logo-main.png`
      banner = `${this.partnerID}-banner.png`
    }

    this.getProfileDetails()
    this.getImage(navLogo, 'navLogo')
    this.getImage('favicon.png', 'favicon')
    this.getImage(banner, 'bgImage')
  }
}
</script>

<style>

</style>

